// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('custactCalcPick', {
//         templateUrl: 'views/components/views/custactCalcPick/custactCalcPick.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'stateService', 'modalService', 'logisticService', 'custactCalcPickService', 'economyService', 'rememberService', function ($stateParams, utilityService, stateService, modalService, logisticService, custactCalcPickService, economyService, rememberService) {

//             // #region VARIABLES & DEFINITIONS
            
//             const vm = this;
//             let p2PoFinishKeyno = $stateParams.p2_pofinish_keyno;
//             let custactNo = $stateParams.custact_no;

//             let variableNames = {
//                 p2PoFinishKeyno: '',
//                 bg_custactcalc_view: '',
//                 filtervalue: ''
//             };

//             vm.model = {
//                 bgCalcView: {
//                     selected: 'INFO',
//                     buttons: [
//                         { id: 'INFO', label: 'bg_custactcalc_view_info', color: 'primary', onClick: () => setCalcView('INFO') },
//                         { id: 'PICK', label: 'bg_custactcalc_view_pick', color: 'primary', onClick: () => setCalcView('PICK') },
//                         { id: 'PICKED', label: 'bg_custactcalc_view_picked', color: 'primary', onClick: () => setCalcView('PICKED') }
//                     ]
//                 },
//                 filterValueButtons: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('filtervalue') },
//                     { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator() }
//                 ],
//                 info: {},
//                 setting: {},
//                 selectListStockPlaces: [],
//                 itemsListComponents: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region BUTTON RADIO FUNCTIONS

//             function setCalcView(id) {
//                 vm.model.bgCalcView.selected = vm.model.setting.bg_custactcalc_view = id;
//             }

//             // #endregion BUTTON RADIO FUNCTIONS

//             // #region LOAD PROCEDURE CALLS
            
//             async function loadInfo() {
//                 vm.model.info = (await economyService.getCustomerActivity({ custact_no: custactNo }))[0];
//             }

//             async function loadSetting() {
//                 vm.model.setting = (await custactCalcPickService.getSetting({
//                     p2_pofinish_keyno: p2PoFinishKeyno,
//                     custact_no: custactNo
//                 }))[0];
//             }

//             async function loadStockPlaces() {
//                 if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                 return vm.model.selectListStockPlaces = (await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no }));
//             }

//             async function loadComponents() {
//                 if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.setting.bg_custactcalc_view) !== true) return;

//                 if (vm.model.setting.bg_custactcalc_view !== 'INFO') {
//                     return vm.model.itemsListComponents = (await custactCalcPickService.listComponents({
//                         p2_pofinish_keyno: p2PoFinishKeyno,
//                         custact_no: custactNo,
//                         bg_custactcalc_view: vm.model.setting.bg_custactcalc_view,
//                         stockplace_id: vm.model.setting.stockplace_id
//                     }));
//                 }
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             function rememberFunc(id) {
//                 Object.keys(variableNames).forEach((key) => {
//                     switch (key) {
//                         case 'p2PoFinishKeyno':
//                             variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                             break;
//                         case 'bg_custactcalc_view':
//                         case 'filtervalue':
//                             variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key + '/' + p2PoFinishKeyno + '/' + custactNo;
//                             break;
//                         default:
//                             break;
//                     }
//                 });

//                 if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                 let variableValue = null;

//                 switch (id) {
//                     case 'p2PoFinishKeyno':
//                         if (utilityService.validateParmsValue(custactNo) !== true) return;

//                         variableValue = custactNo;
//                         break;
//                     case 'bg_custactcalc_view':
//                         if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     case 'filtervalue':
//                         if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     default:
//                         break;
//                 }

//                 return rememberService.remember(variableNames[id], variableValue);
//             }

//             // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             // #region SCAN FUNCTION

//             function loadScan() {
//                 if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                 custactCalcPickService.scanStockSearch({
//                     functionname: 'trmenu',
//                     barcode: vm.model.setting.filtervalue,
//                     stockplace_id: vm.model.setting.stockplace_id
//                 }).then((response) => {
//                     stateService.go(response[0].webpagename, response[0].parms);
//                 });
//             }

//             // #endregion SCAN FUNCTION

//             // #region RESET BUTTON FUNCTION

//             function clear(id) {
//                 switch (id) {
//                     case 'filtervalue':
//                         vm.model.setting.filtervalue = '';

//                         if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion RESET BUTTON FUNCTION

//             // #region CALCULATOR FUNCTION

//             function openCalculator() {
//                 modalService.showCalculator(vm.model.setting.filtervalue).then(function (value) {
//                     vm.model.setting.filtervalue = value;

//                     rememberFunc('filtervalue');
//                 });
//             }

//             // #endregion CALCULATOR FUNCTION

//             // #region BUTTON RADIO FUNCTIONS

//             vm.selectBgCalcView = function (value) {
//                 vm.model.bgCalcView.selected = value;
//                 vm.model.setting.bg_custactcalc_view = vm.model.bgCalcView.selected;

//                 rememberFunc('bg_custactcalc_view');
//                 loadComponents();
//             }

//             // #endregion BUTTON RADIO FUNCTIONS

//             // #region MULTI DIRECTION BUTTON FUNCTIONS

//             vm.goToFunc = function (state, e) {
//                 function go(parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 }

//                 switch (state) {
//                     case 'productsearch':
//                         if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

//                         rememberService.remember('w_custactcalcpick.filtervalue_new', vm.model.setting.filtervalue).then(() => {
//                             loadScan();
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'filtervalue':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.filtervalue) !== true) return;

//                         vm.model.setting.filtervalue = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.filtervalue, true) !== true) return;

//                         if (vm.model.setting.filtervalue === '') rememberFunc('filtervalue');
//                         break;
//                     case 'stockplace_id':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

//                         vm.model.setting.stockplace_id = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

//                         loadComponents();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON BLUR MULTI FUNCTIONS

//             vm.onBlur = function (id) {
//                 switch (id) {
//                     case 'filtervalue':
//                         if (utilityService.validateParmsValue(vm.model.setting.filtervalue) !== true) return;

//                         if (vm.model.setting.filtervalue > '') rememberFunc('filtervalue');
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion ON BLUR MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadInfo();
//                 await loadSetting();
//                 rememberFunc('p2PoFinishKeyno');
//                 setCalcView(vm.model.setting.bg_custactcalc_view);
//                 loadComponents();
//                 loadStockPlaces();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
